import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { FunctionDesc } from '../../models/configuration.model';
import { ConfigurationStoreService } from '../configuration-store/configuration-store.service';
import { CustomService } from '../custom/custom.service';
import { BafAgentService } from '../../core/services/baf-agent/baf-agent.service';

@Injectable()
export class FunctionStoreService implements OnDestroy {
  private isAlive = true;
  private allFunctions = new BehaviorSubject<FunctionDesc[]>([]);
  private selectedFunction = new BehaviorSubject<FunctionDesc>(null);

  constructor(
    configurationStore: ConfigurationStoreService,
    private customService: CustomService,
    private bafAgent: BafAgentService
  ) {
    configurationStore.configurationStream.takeWhile(() => this.isAlive).subscribe(config => {
      if (config) {
        const functions = config.application.modules[0].functions;
        this.complementCounters(functions);
        this.allFunctions.next(functions);
        if (functions) {
          this.selectedFunction.next(this.getChildren(functions[0].functions)[0]);
        } else {
          this.selectedFunction.next(null);
        }
      }
    });
  }

  get allFunctionsValue(): FunctionDesc[] {
    return this.allFunctions.getValue();
  }

  get allFunctionsStream(): Observable<FunctionDesc[]> {
    return this.allFunctions.asObservable();
  }

  get selectedFunctionValue(): FunctionDesc {
    return this.selectedFunction.getValue();
  }

  get selectedFunctionStream(): Observable<FunctionDesc> {
    return this.selectedFunction.asObservable();
  }

  refreshFunctions(): void {
    const functions = this.allFunctions.value;
    this.complementCounters(functions);
    this.allFunctions.next(functions);
  }

  selectFunction(functionId: string) {
    const selectedFunction = this.allFunctions.getValue().find(func => func.id === functionId);
    this.selectedFunction.next(selectedFunction);
  }

  private getChildren(parents: FunctionDesc[]): FunctionDesc[] {
    if (parents) {
      if (parents.length > 0 && parents[0].functions.length > 0) {
        return this.getChildren(parents[0].functions);
      } else {
        return parents;
      }
    } else {
      return parents;
    }
  }

  ngOnDestroy() {
    this.isAlive = false;
  }

  private complementCounters(functions: FunctionDesc[]) {
    if (functions && functions.length > 0) {
      const types: string[] = [];
      functions[0].functions.forEach(element => {
        const type = this.customService.getTypeById(element.id);
        types.push(type);
      });
      this.bafAgent.NotificationCount(types).subscribe(result => {
        functions[0].functions.forEach(element => {
          const type = this.customService.getTypeById(element.id);
          element.notificationCount = result.values[type];
        });
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/function-store/function-store.service.ts